// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"175":"locale0","366":"locale1","781":"locale2","972":"locale3"}[chunkId] || chunkId) + "." + {"175":"55751d74","366":"e6b43c66","510":"ec5851bd","781":"893dbf64","972":"7fc3cda9"}[chunkId] + ".chunk.js";
};